import { render, staticRenderFns } from "./footerRow.vue?vue&type=template&id=04e79f88&scoped=true"
import script from "./footerRow.vue?vue&type=script&lang=js"
export * from "./footerRow.vue?vue&type=script&lang=js"
import style0 from "./footerRow.vue?vue&type=style&index=0&id=04e79f88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e79f88",
  null
  
)

export default component.exports